import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "panel"]

  connect() {
    this.#sync()
  }

  toggle() {
    this.#sync()
  }

  #sync() {
    if (!this.hasCheckboxTarget || !this.hasPanelTarget) return

    const enabled = this.checkboxTarget.checked
    this.panelTarget.classList.toggle("hidden", !enabled)
    this.panelTarget.setAttribute("aria-hidden", String(!enabled))
    this.panelTarget.querySelectorAll("input, select, textarea, button").forEach((control) => {
      control.disabled = !enabled
    })
  }
}
